"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var IdGenerator_1 = require("../../utils/IdGenerator");
var CapabilityProvider_1 = require("../CapabilityProvider");
var Provider_types_1 = require("./Provider.types");
var THEME;
(function (THEME) {
    THEME["neutral"] = "";
    THEME["ergodirekt"] = "ergodirekt";
    THEME["ergo"] = "ergo";
    THEME["das"] = "das";
    THEME["dkv"] = "dkv";
    THEME["ergo-one"] = "ergo-one";
    THEME["ergoone"] = "ergo-one";
})(THEME = exports.THEME || (exports.THEME = {}));
__export(require("./Provider.types"));
exports.ErgoElementsContext = React.createContext({
    idGenerator: new IdGenerator_1.IdGenerator('implicit_context'),
    theme: ''
});
var propTypes = {
    theme: PropTypes.oneOf(['', 'ergo', 'ergo-one', 'ergodirekt', 'das', 'dkv']),
    contextName: PropTypes.string,
    idGenerator: PropTypes.shape({
        next: PropTypes.func.isRequired
    }),
    children: PropTypes.node.isRequired,
    capabilities: PropTypes.arrayOf(PropTypes.element)
};
/**
 * A `Provider` component can be used to set a theme for its child components.
 *
 * Technically an HTML attribute will be set to the root `div` element which is
 * used in CSS selectors of the component library that are responsible for theming.
 */
var Provider = /** @class */ (function (_super) {
    __extends(Provider, _super);
    function Provider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.idGenerator =
            props.idGenerator || new IdGenerator_1.IdGenerator(_this.props.contextName);
        return _this;
    }
    Provider.prototype.getContext = function () {
        return {
            idGenerator: this.idGenerator,
            theme: this.props.theme
        };
    };
    Provider.prototype.componentDidMount = function () {
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production' &&
            process.env.NODE_ENV !== 'test') {
            if (!Provider.devHintProvided &&
                Provider_types_1.styleGuideUrl // only available during build step
            ) {
                // tslint:disable-next-line:no-console
                console.info("Wir haben bemerkt, dass du ERGO Elements benutzt. Falls du Hilfe brauchst klicke hier: " + Provider_types_1.styleGuideUrl);
                Provider.devHintProvided = true;
            }
        }
    };
    Provider.prototype.render = function () {
        var _a = this.props, theme = _a.theme, contextName = _a.contextName, idGenerator = _a.idGenerator, children = _a.children, capabilities = _a.capabilities, className = _a.className, other = __rest(_a, ["theme", "contextName", "idGenerator", "children", "capabilities", "className"]);
        return (React.createElement("div", __assign({}, other, { className: className, "data-theme": theme, "data-version": Provider_types_1.elementsVersion, "data-root": true }),
            React.createElement(exports.ErgoElementsContext.Provider, { value: this.getContext() }, _super.prototype.render.call(this, children))));
    };
    Provider.propTypes = propTypes;
    Provider.defaultProps = {
        theme: THEME.neutral,
        contextName: undefined,
        idGenerator: undefined,
        capabilities: []
    };
    Provider.devHintProvided = false;
    return Provider;
}(CapabilityProvider_1.default));
exports.Provider = Provider;
exports.default = Provider;
//# sourceMappingURL=Provider.js.map
